/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Intro_P1Inputs */

const en_pc_alt_intro_p1 = /** @type {(inputs: Pc_Alt_Intro_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft (github.com/storytold/pdfcraft) is a free, open-source PDF editor from the ArtCraft team. It is good at reading, commenting, filling forms and moving pages around, and it is open about being alpha software. That leaves real gaps, and depending on your work another tool may simply be the better choice.`)
};

const zh_pc_alt_intro_p1 = /** @type {(inputs: Pc_Alt_Intro_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft（github.com/storytold/pdfcraft）是 ArtCraft 团队开发的免费开源 PDF 编辑器。它擅长阅读、批注、填写表单和调整页面，也坦率承认自己仍是 alpha 软件。这意味着它确实有短板，根据你的工作内容，其他工具可能才是更好的选择。`)
};

/**
* | output |
* | --- |
* | "PdfCraft (github.com/storytold/pdfcraft) is a free, open-source PDF editor from the ArtCraft team. It is good at reading, commenting, filling forms and movin..." |
*
* @param {Pc_Alt_Intro_P1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_intro_p1 = /** @type {((inputs?: Pc_Alt_Intro_P1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Intro_P1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_intro_p1(inputs)
	return zh_pc_alt_intro_p1(inputs)
});
export { pc_alt_intro_p1 as "pc.alt.intro_p1" }